import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import agrokanLogo from "../../assets/agrokan-logo.svg";
import agrokanproto from "../../assets/agrokan-proto.png";
import carmelita from "../../assets/carmelita.png";
import codelogyCaseStudy from "../../assets/codelogy-case-study.png";
import codelogyLogo from "../../assets/codelogy-logo.png";
import codelogy from "../../assets/codelogy.png";
import codelogyLogoColor from "../../assets/codelogy.svg";
import codelogy1 from "../../assets/codelogy1.png";
import codelogy2 from "../../assets/codelogy2.png";
import codelogy3 from "../../assets/codelogy3.png";
import imperfectLogo from "../../assets/imperfect-logo.png";
import imperfectproto from "../../assets/imperfect-proto.png";
import macbook from "../../assets/macbook.png";
import Process from "../../component/Process";

const Home = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="overflow-hidden">
      <div className="min-h-[70vh] md:min-h-screen flex flex-col bg-black relative">
        <h1 className="text-7xl text-center font-bold mb-10 mt-52 tracking-widest text-transparent bg-clip-text bg-gradient-name">
          UI/UX PORTOFOLIO
        </h1>
        <p className="text-white text-center font-bold text-3xl tracking-widest text-[#FFFBFE]">
          CARMELITA ANGELICA
        </p>
        <img
          src={macbook}
          className="w-full max-h-40vh bottom-0 absolute"
          alt=""
        />
      </div>
      <div className="bg-black">
        <div className="max-w-[90rem] mx-auto py-12 px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10">
            <div className="" data-aos="fade-left" data-aos-duration="1000">
              <p className="font-semibold text-xl tracking-widest text-[#FFFBFE]/[0.7]">
                CASE STUDY
              </p>
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-3">
                CODELOGY - LEARNING
              </h1>
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-2">
                PROGRAMMING MOBILE APP
              </h1>
              <p className="font-semibold text-2xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-12">
                THE PROBLEM
              </p>
              <ol className="list-decimal list-outside ml-3 mt-3">
                <li className="text-[#FFFBFE] text-lg tracking-wider leading-8">
                  There are 40,000 IT graduates produced annually, and only 1%
                  successfully secure positions in large companies and can
                  compete in the global arena.
                </li>
                <li className="text-[#FFFBFE] text-lg tracking-wider leading-8">
                  Many IT students are found to be unable to code due to a lack
                  of learning guidance and difficulties in understanding the
                  material.
                </li>
              </ol>
              <p className="font-semibold text-2xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-7">
                MY ROLE
              </p>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-8 mt-3">
                My role in the success of this project as a UI/UX Designer is to
                execute the design process using the design thinking method,
                create wireframes along with high-fidelity designs, and develop
                prototypes. Following that, I will commence testing using the
                User Experience Question (UEQ) form distribution method.
              </p>
              <p className="font-semibold text-2xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-7 mb-3">
                MY PROCESS
              </p>
              <div className="flex flex-wrap gap-4">
                <Process label="COMPETITIVE REVIEWS" />
                <Process label="USER RESEARCH" />
                <Process label="JOURNEY MAPPING" />
                <Process label="USER STORIES" />
                <Process label="PROTOTYPING" />
                <Process label="WIREFRAMING" />
                <Process label="USER FLOWS" />
                <Process label="INFORMATION ARCHITECTURE" />
                <Process label="USER TESTING" />
              </div>
            </div>
            <div
              className="flex items-center justify-center relative mt-20 md:mt-0"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <img
                src={codelogyLogo}
                className="absolute w-1/2 -z-1 md:-mt-40 -mt-20"
                alt=""
              />
              <img src={codelogy} className="w-full" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div
          className="max-w-[90rem] mx-auto py-24 px-4"
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          <p className="font-semibold text-xl tracking-widest text-[#FFFBFE]/[0.7]">
            PROCESS SAMPLES
          </p>
          <div className="flex justify-between">
            <h1 className="font-bold text-4xl text-[#FFFBFE] mt-3">
              CODELOGY - LEARNING PROGRAMMING MOBILE APP
            </h1>
            <img src={codelogyLogoColor} alt="" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-14 md:gap-y-0 gap-y-14 mt-5">
            <div className="">
              <img src={codelogy1} className="w-full" alt="" />
              <h1 className="font-bold text-xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-5">
                UX STRATEGY & RESEARCH
              </h1>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-6 text-justify mt-3">
                Based on the survey conducted with respondents, both from
                students within FILKOM (Faculty of Computer Science) and those
                outside FILKOM, many students are interested in learning
                programming languages to enhance their skills. Additionally,
                they face difficulties in learning due to the lack of
                interactive learning methods..
              </p>
            </div>
            <div className="">
              <img src={codelogy2} className="w-full" alt="" />
              <h1 className="font-bold uppercase text-xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-5">
                Design System & Style Guide
              </h1>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-6 text-justify mt-3">
                As part of the design platform, I take the opportunity to build
                a design library consisting of components, fonts, colors, logos,
                etc.
              </p>
            </div>
            <div className="">
              <img src={codelogy3} className="w-full" alt="" />
              <h1 className="font-bold uppercase text-xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-5">
                Wireframe
              </h1>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-6 text-justify mt-3">
                I am identifying the features needed for the target users and
                starting to compile a list of key features. After that, I begin
                designing wireframes for the listed features.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className="max-w-[90rem] mx-auto py-24 px-4">
          <p className="font-semibold text-xl tracking-widest text-[#FFFBFE]/[0.7]">
            CASE STUDY
          </p>
          <div className="flex justify-between">
            <div className="">
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-3">
                CODELOGY - LEARNING
              </h1>
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-2">
                PROGRAMMING MOBILE APP
              </h1>
            </div>
            <img src={codelogyLogoColor} alt="" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10">
            <div className="" data-aos="fade-left" data-aos-duration="1000">
              <p className="font-semibold text-2xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-7">
                TESTING RESULTS
              </p>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-8 mt-3">
                I have developed a prototype for the Codelogy application,
                designed to assist users in learning programming. Employing the
                User-Centered Design (UCD) method, the application comprises 33
                screens and features 4 main functionalities. In user assessments
                using the User Experience Questionnaire (UEQ), the application
                received an overall rating of "good."
              </p>
              <p className="font-semibold text-2xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-7">
                SUMMARY
              </p>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-8 mt-3">
                I have created a prototype for the Codelogy application with the
                goal of aiding users in learning programming. This involved
                employing the User-Centered Design (UCD) method throughout the
                design process, resulting in a total of 33 screens housing 4
                main features. The application underwent user assessment using
                the User Experience Questionnaire (UEQ), and it achieved an
                average rating of "Good" in terms of user satisfaction and
                experience.
              </p>
            </div>
            <div
              className="flex flex-col justify-center mt-14 md:mt-5"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <img src={codelogyCaseStudy} className="w-full" alt="" />
              <p className="uppercase font-semibold text-2xl text-transparent bg-clip-text bg-gradient-mesh-h3 mt-10 mb-4">
                user sentiment
              </p>
              <div className="flex gap-x-5 items-center">
                <div className="rounded-full bg-[#CBBCB8] w-full">
                  <div className="rounded-l-full bg-gradient-bar md:w-[96%] w-[90%]">
                    <p className="text-center font-semibold text-3xl text-[#5E014F] py-2">
                      YES !
                    </p>
                  </div>
                </div>
                <p className="text-transparent bg-clip-text bg-gradient-mesh-h3 font-semibold text-3xl">
                  96%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className="max-w-[90rem] mx-auto py-24 px-4">
          <div className="flex justify-between">
            <p className="font-semibold uppercase text-xl tracking-widest text-[#FFFBFE]/[0.7]">
              More Project Samples
            </p>
            <img src={imperfectLogo} alt="" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-x-10">
            <img
              src={imperfectproto}
              className="w-full"
              data-aos="fade-left"
              data-aos-duration="1000"
              alt=""
            />
            <div className="" data-aos="fade-right" data-aos-duration="1000">
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-3">
                I'M PERFECT -
              </h1>
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-2">
                MARKETPLACE FOR
              </h1>
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-2">
                IMPERFECT PRODUCE
              </h1>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-8 mt-5">
                "I'm Perfect" is a cross-platform website and mobile app-based
                marketplace that assists farmers in selling their imperfect
                harvests. Users can buy and sell imperfect produce, similar to
                Tokopedia and Shopee. Sellers can undergo a verification process
                to instill confidence in buyers. Meanwhile, buyers only need to
                register to make transactions. The website for "I'm Perfect"
                will be developed using React JS for the front-end and Node JS
                for the back-end. The mobile app will be developed using Kotlin.
              </p>
              <div className="flex flex-wrap gap-4 mt-7">
                <Process label="DESIGN SYSTEM" />
                <Process label="USER FLOW" />
                <Process label="WIREFRAMING" />
                <Process label="PROTOTYPE" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className="max-w-[90rem] mx-auto py-24 px-4">
          <div className="flex justify-between">
            <p className="font-semibold uppercase text-xl tracking-widest text-[#FFFBFE]/[0.7]">
              More Project Samples
            </p>
            <img src={agrokanLogo} alt="" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 mt-10 gap-x-10">
            <img
              src={agrokanproto}
              className="w-full px-5"
              alt=""
              data-aos="fade-left"
              data-aos-duration="1000"
            />
            <div
              className="md:mt-0 mt-10"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-3">
                AGROKAN -
              </h1>
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-2">
                AGRICULTURAL
              </h1>
              <h1 className="font-bold text-4xl text-[#FFFBFE] mt-2">
                ENTERPRISE
              </h1>
              <p className="text-[#FFFBFE] text-lg tracking-wider leading-8 mt-5">
                The Agrokan application is a service in the field of agriculture
                or agribusiness, specifically aimed at enhancing national food
                security. To boost interest and knowledge in agriculture, we
                provide educational services where users can learn various
                materials and watch videos related to farming based on specific
                topics. Additionally, users can make purchases or rentals
                related to agricultural equipment. Another effort to increase
                public interest in agriculture is by introducing educational
                tours (agritourism), where users can easily and quickly search
                for educational tours and book tickets online.
              </p>
              <div className="flex flex-wrap gap-4 mt-7">
                <Process label="DESIGN SYSTEM" />
                <Process label="USER FLOW" />
                <Process label="WIREFRAMING" />
                <Process label="PROTOTYPE" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className="max-w-6xl mx-auto py-24 px-4">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="" data-aos="fade-left" data-aos-duration="1000">
              <h1 className="font-bold text-5xl text-[#FFFBFE]">CONTACT ME</h1>
              <div className="flex flex-col gap-y-5 mt-20">
                <p
                  href="#"
                  className="text-transparent bg-clip-text bg-gradient-mesh-h3 font-medium text-3xl"
                >
                  +62 812 4767 2687
                </p>
                <a
                  href="mailto: angiesiregar804@gmail.com"
                  className="text-transparent bg-clip-text bg-gradient-mesh-h3 font-medium text-3xl"
                >
                  angiesiregar804@gmail.com
                </a>
                <a
                  href="https://www.linkedin.com/in/carmelitaas/"
                  target="blank"
                  className="text-transparent bg-clip-text bg-gradient-mesh-h3 font-medium text-3xl"
                >
                  linkedin.com/in/carmelitaas/
                </a>
                <a
                  href="https://dribbble.com/carmelitaas"
                  target="blank"
                  className="text-transparent bg-clip-text bg-gradient-mesh-h3 font-medium text-3xl"
                >
                  dribbble.com/carmelitaas
                </a>
              </div>
            </div>
            <div
              className="flex items-center justify-center"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <img src={carmelita} className="w-2/3 mt-14 md:mt-0" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
